import cx from 'classnames'

import { TableRow } from './row'
import {
  styles,
  tableOverflowStyles,
  wrapperOverflowStyles,
} from './table.styles'
import type { TableProps } from './table.types'

export function Table({
  rows,
  overflow = 'scroll',
  className = '',
  tableClassName = '',
  ...tableProps
}: TableProps) {
  const headRows = rows.filter((row) => row.heading)
  const bodyRows = rows.filter((row) => !row.heading)

  return (
    <div
      className={cx(styles.wrapper, wrapperOverflowStyles[overflow], className)}
    >
      <table
        className={cx(
          styles.table,
          tableOverflowStyles[overflow],
          tableClassName,
        )}
        {...tableProps}
      >
        {headRows.length > 0 && (
          <thead>
            {headRows.map((row, rowIndex) => (
              <TableRow key={`head-${rowIndex}`} {...row} />
            ))}
          </thead>
        )}
        {bodyRows.length > 0 && (
          <tbody>
            {bodyRows.map((row, rowIndex) => (
              <TableRow key={`body-${rowIndex}`} {...row} />
            ))}
          </tbody>
        )}
      </table>
    </div>
  )
}
